import { AttachPosition, Direction } from 'webapp/enums/enums';

import type PopupWrapperContextComponent from 'webapp/components/popup/wrapper/context';

import type { PopupProps } from 'webapp/models-custom/popup/base';
import PopupBase from 'webapp/models-custom/popup/base';

// Context popup v3

export interface PopupContextProps extends PopupProps {
	attachTo: HTMLElement;
	// controls the position of attach point on the popup
	// e.g Direction.DOWN means the popup is attached at the bottom of the attachTo element
	// if attachPosition is "start" the popups attach point is its top left corner (left corner of the popup is centered with the attachTo element)
	attachPosition?: AttachPosition;
	// if attachPosition is specified, this controls how much the popup is moved to the right/left/top/bottom of the attach point
	// e.g Direction.DOWN and attachPosition.START
	// the props above will show the popup below the attachTo element, popups left side will be at the center of the attachTo element
	// if attachPositionOffset is set to 10, the attach point will move 10px to the right of the top left corner of the popup
	attachPositionOffset?: number;
	directions?: Direction[];
	offset?: number;
	closeOnOutsideClickInModal?: boolean;
	neverFullwidth?: boolean;
	inheritWidth?: boolean;
	skipAttachToCheck?: boolean;
	// if alignEdgeWithAttachTo is true, the attachPositionOffset will be calculated based on Direction and attachPosition
	// the calculated value will align the edge of the popup with the edge of the attachTo element
	// e.g. Direction.DOWN, attachPosition.START, alignEdgeWithAttachTo = true will align left edge of popup with left edge of attachTo element
	alignEdgeWithAttachTo?: boolean;
	hideArrow?: boolean;
	onChangeDirection?: (direction: Direction) => void;
	onBeforeReposition?: (node: HTMLElement) => void;
}

export default class PopupContext extends PopupBase {
	override component: PopupWrapperContextComponent | null = null;

	override get isContext(): boolean {
		return true;
	}

	attachPosition = AttachPosition.CENTER;
	attachPositionOffset = 16;
	offset = 5;
	directions = [Direction.DOWN, Direction.RIGHT, Direction.UP, Direction.LEFT]; // allowed directions (in the preferred order)
	closeOnOutsideClickInModal = true;
	neverFullwidth = false;
	inheritWidth = false;
	skipAttachToCheck = false;
	alignEdgeWithAttachTo = false;
	hideArrow = false;
	onChangeDirection: ((direction: Direction) => void) | null = null;
	onBeforeReposition: ((node: HTMLElement) => void) | null = null;

	attachTo: HTMLElement | null = null;

	constructor(props: PopupContextProps) {
		super(props);

		this.attachTo = props.attachTo;

		if (typeof props.directions !== 'undefined') {
			this.directions = props.directions;
		}

		if (typeof props.offset !== 'undefined') {
			this.offset = props.offset;
		}

		if (typeof props.closeOnOutsideClickInModal !== 'undefined') {
			this.closeOnOutsideClickInModal = props.closeOnOutsideClickInModal;
		}

		if (typeof props.neverFullwidth !== 'undefined') {
			this.neverFullwidth = props.neverFullwidth;
		}

		if (typeof props.inheritWidth !== 'undefined') {
			this.inheritWidth = props.inheritWidth;
		}

		if (typeof props.skipAttachToCheck !== 'undefined') {
			this.skipAttachToCheck = props.skipAttachToCheck;
		}

		if (typeof props.attachPosition !== 'undefined') {
			this.attachPosition = props.attachPosition;
		}

		if (typeof props.attachPositionOffset !== 'undefined') {
			this.attachPositionOffset = props.attachPositionOffset;
		}

		if (typeof props.alignEdgeWithAttachTo !== 'undefined') {
			this.alignEdgeWithAttachTo = props.alignEdgeWithAttachTo;
		}

		if (typeof props.hideArrow !== 'undefined') {
			this.hideArrow = props.hideArrow;
		}

		if (typeof props.onChangeDirection !== 'undefined') {
			this.onChangeDirection = props.onChangeDirection;
		}

		if (typeof props.onBeforeReposition !== 'undefined') {
			this.onBeforeReposition = props.onBeforeReposition;
		}
	}
}
